import axios from "axios";
import { put, takeLatest } from "redux-saga/effects";
import { GET_LOGIN_BY_ID } from "../types/types";
import {
  getLoginErrorAction,
  getLoginSuccessAction,
} from "../slices/loginSlice";

function* getLoginSaga({ payload: id }) {
  try {
    const response = yield axios.get(``);
    console.log(response);
    yield put(getLoginSuccessAction());
  } catch (error) {
    yield put(getLoginErrorAction(error));
  }
}

export function* watchGetLogin() {
  yield takeLatest(GET_LOGIN_BY_ID, getLoginSaga);
}
